// extracted by mini-css-extract-plugin
export default {"categoryHeading":"TitleV1_categoryHeading__bNqZA"};